<template>
    <section class="slice slice-trends-carousel" :class="{'slice-trends-carousel--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <TitleBrand v-if="props.slice.primary.title" :field="props.slice.primary.title" class="text-center" />
            <TrendsCarousel v-if="props.slice.primary.cards" :items="props.slice.primary.cards">
                <template #card="{item}">
                    <TrendsDetailCard :card="trendsCardFromSlot(item)" />
                </template>
            </TrendsCarousel>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps} from '@prismicio/vue';

    import type {TrendsDetailsCarouselSliceDefaultPrimaryCardsItem} from '@prismicio-types';
    import 'swiper/css';
    import 'swiper/css/pagination';
    import TitleBrand from '~/components/TitleBrand.vue';
    import TrendsCarousel from '~/components/trends/TrendsCarousel.vue';
    import TrendsDetailCard from '~/components/trends/TrendsDetailCard.vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsDetailsCarouselSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);

    // No other way to type the item in the slot ...
    function trendsCardFromSlot(item: unknown): TrendsDetailsCarouselSliceDefaultPrimaryCardsItem {
        return item as TrendsDetailsCarouselSliceDefaultPrimaryCardsItem;
    }
</script>

<style lang="scss">
    .slice-trends-carousel {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }
    }
</style>
